import React from "react";

export default function SectionHeading({ children, as: Tag = "h2", className = "" }) {
  return (
    <Tag
      className={`text-xl font-semibold tracking-tight text-neutral-900 dark:text-white sm:text-2xl ${className}`}
    >
      {children}
    </Tag>
  );
}
